import {
  Box,
  Button as CButton,
  CircularProgress,
  Container,
  FormControl,
  Heading,
  HStack,
  Image,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  Textarea,
  useDisclosure,
  useToast,
  FormLabel,
  FormHelperText,
  Skeleton,
  Breadcrumb,
  BreadcrumbItem,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Assets
import BTC from "../../../assets/icons/p2p2v2/icons/btc.svg";
import ETH from "../../../assets/icons/p2p2v2/icons/eth.svg";
import USDT from "../../../assets/icons/p2p2v2/icons/teth.svg";
import CUSD from "../../../assets/png/cusd.png";
import CELO from "../../../assets/icons/p2p2v2/icons/celo.svg";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Steps, { StepContent } from "components/Steps/Steps";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import { useSteps } from "components/Steps/provider";
import { useCallback, useEffect, useState } from "react";
import NumberInput from "components/Input/NumberInput";
import Button from "components/Button/Button";
import AddPaymentMethod from "components/Modals/p2p/AddPaymentMethod";
import ListingPreview from "components/Modals/p2p/ListingPreview";
import {
  useUpdateListingMutation,
  useGetListingByIdQuery,
} from "services/p2pApi";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import isEmpty from "lodash/isEmpty";
// import { deduction } from "util/utils";
// import { useStore } from "store";
import { toLower } from "lodash";
import SuccessModal from "components/Modals/Success";
import { useGetRateQuery } from "services/rateApi";

import toCoinLocale from "util/toCoinLocale";

const steps = [
  { label: "Pricing" },
  { label: "Payment Method" },
  { label: "Terms" },
];

const iniState = {
  methods: [],
  type: "buy",
  volume: null,
  sourceUnit: "ngn",
  destinationUnit: "btc",
  totalCost: 0,
  acceptPartialFilling: true,
  useInternalWallet: false,
  dynamic: false,
  country: null,
  location: null,
  minimumFilling: null,
  maximumFilling: null,
  price: null,
  unitCost: null,
  timeout: 15,
  terms: null,
  instructions: null,
  paymentOption: [],
};

export const transformListingToState = (listing) => {
  const typeMap = {
    selling: "sell",
    buying: "buy",
  };

  const listingTypeMap = {
    buy: "destinationUnit",
    sell: "sourceUnit",
  };

  const mapUnitField = (type) => {
    return listing && listing[listingTypeMap[type]];
  };

  const getPaymentOptions = (data) => {
    let options = [];
    data?.paymentOption?.forEach((option) => {
      if (
        toLower(option.label) === "bitmama wallet" &&
        option.source === "internal"
      )
        options.push({ key: "bitmamaWallet", label: option.label });
      if (
        toLower(option.label) === "external wallet" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) === "changera"
      ) {
        options.push({ key: "changeraId", label: option.receivingIntoLabel });
      }
      if (
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "changera" &&
        option.source === "external" &&
        toLower(option.receivingIntoLabel) !== "bitmama wallet"
      ) {
        options.push({ key: "bankTransfer", label: "Bank Transfer" });
      }
    });

    return options;
  };

  const options = getPaymentOptions(listing)?.map((m) => m.key);

  return {
    methods: [...options],
    type: typeMap[listing?.adsType],
    token: mapUnitField(typeMap[listing?.adsType]),
    volume: listing?.volume?.$numberDecimal,
    totalCost: listing?.totalCost?.$numberDecimal,
    sourceUnit: listing?.sourceUnit,
    destinationUnit: listing?.destinationUnit,
    useInternalWallet: options?.includes("bitmamaWallet"),
    dynamic: listing?.dynamic,
    country: listing?.country,
    minimumFilling: listing?.tradeOption?.minimumFilling,
    maximumFilling: listing?.tradeOption?.maximumFilling,
    acceptPartialFilling: listing?.tradeOption?.acceptPartialFilling,
    price: listing?.price,
    unitCost: listing?.tradeOption?.unitCost,
    timeout: listing?.timeout,
    terms: listing?.terms ?? "N/A",
    instructions: listing?.instructions ?? "N/A",
    paymentOption: listing?.paymentOption.map((po, i) => ({
      ...po,
      method: options[i],
      receivingIntoAddress: po?.receivingIntoAddress || po?.address,
    })),
  };
};

// const floatString = (n) =>
//   (n && (Number.isInteger(n) ? n.toFixed(1) : n.toString())) ?? "";

const floatString = (n) =>
  (n && (Number.isInteger(n) ? n.toFixed(1) : n)) ?? "";

const CoinButton = ({ icon, selected, label, onClick, isLoaded, ...rest }) => {
  return (
    <Skeleton isLoaded={isLoaded}>
      <CButton
        onClick={onClick}
        maxH="40px"
        bg="transparent"
        border="1px solid transparent"
        borderColor={selected ? "var(--primary)" : "transparent"}
        fontSize="sm"
        fontWeight="400"
        h="40px"
        _hover={{
          bg: "transparent",
        }}
        _focus={{
          shadow: "0 0 0 3px var(--focusColor)",
        }}
        {...rest}
      >
        <HStack>
          <Image boxSize="16px" src={icon} />
          <Text>{label}</Text>
        </HStack>
      </CButton>
    </Skeleton>
  );
};

const Step1 = ({ state, setState, isLoaded }) => {
  const { onNext, onPrev, hasPrevStep } = useSteps();

  const listingTypeMap = {
    buy: "destinationUnit",
    sell: "sourceUnit",
  };

  const dynamicsMap = {
    true: "price",
    false: "unitCost",
  };

  const mapUnitField = (type) => {
    return state[listingTypeMap[type]];
  };

  const mapSrcUnitField = (type) => {
    const buyMap = {
      sell: "destinationUnit",
      buy: "sourceUnit",
    };
    return state[buyMap[type]];
  };

  const mapDestUnitField = (type) => {
    const sellMap = {
      sell: "sourceUnit",
      buy: "destinationUnit",
    };
    return state[sellMap[type]];
  };

  // const ticker = `${toLower(
  //   !state?.dynamic ? mapDestUnitField(state.type) : "usd"
  // )}${toLower(mapSrcUnitField(state.type))}`;

  const getTicker = () => {
    const sourceMap = {
      btc: "btc",
      eth: "eth",
      usdt: "usd",
      celo: "celo",
      cusd: "usd",
    };

    if (state.dynamic) return `usd${toLower(mapSrcUnitField(state.type))}`;
    return `${sourceMap[state.token]}${toLower(mapSrcUnitField(state.type))}`;
  };

  const {
    data: rateData,
    isLoading: isCheckingRate,
    isFetching: isUpdatingRate,
  } = useGetRateQuery(getTicker());

  const coins = [
    { value: "btc", label: "BTC", icon: BTC },
    { value: "eth", label: "ETH", icon: ETH },
    { value: "usdt", label: "USDT", icon: USDT },
    { value: "celo", label: "CELO", icon: CELO },
    { value: "cusd", label: "cUSD", icon: CUSD },
  ];

  // console.log(
  //   "STATE",
  //   state,
  //   "\nSOURCE UNIT",
  //   mapSrcUnitField(state.type),
  //   "\nDESTINATION UNIT",
  //   mapDestUnitField(state.type)
  // );

  // console.log("SELECTED COIN", mapUnitField(state.type));

  const getRate = () =>
    Number((rateData && rateData?.exchangeRate[state.type]) ?? 1);
  const getMarkUp = () => getRate() * 2;
  const getMarkDown = () => getRate() * 0.4;

  const isPriceInvalid = () =>
    state[dynamicsMap[String(state?.dynamic)]] &&
    (state[dynamicsMap[String(state?.dynamic)]] < getMarkDown() ||
      state[dynamicsMap[String(state?.dynamic)]] > getMarkUp());

  const getTotalCost = () => {
    // if (state.type === "sell" && state?.volume)
    // return Number(
    //   state[dynamicsMap[String(state?.dynamic)]] * volume(state?.volume)
    // );
    return Number(state[dynamicsMap[String(state?.dynamic)]] * state?.volume);
  };

  const isMinimumInvalid = () =>
    (state?.minimumFilling && state?.minimumFilling <= 0) ||
    state.minimumFilling > state.volume;

  const isMaximumInvalid = () =>
    (state?.maximumFilling &&
      state.volume &&
      Number(state?.maximumFilling) > Number(state?.volume)) ||
    (state?.maximumFilling && state?.maximumFilling <= 0);

  const getMaximumFilling = () => {
    // if (state.type === "sell" && state?.volume)
    // return Number(state.volume - deduction(state.volume));
    return Number(state.volume);
  };

  const getCurrentMarketRate = () => {
    return `Current market rate: 1 ${toCoinLocale(
      !state?.dynamic ? mapDestUnitField(state.type) : "usd"
    )} = ${Number(rateData?.exchangeRate[state.type]).toFixed(
      4
    )} ${toCoinLocale(mapSrcUnitField(state.type))}`;
  };

  const setMaximumFilling = (val) => {
    const max = getMaximumFilling();
    if (+val > max) return String(max);
    return val;
  };

  const setMinimumFilling = (val) => {
    const max = getMaximumFilling();
    if (+val > max) return String(max);
    return val;
  };

  // console.log("MAXIMUM FILLING", getMaximumFilling());

  const isDisabled = () =>
    !(
      state[dynamicsMap[String(state?.dynamic)]] &&
      state?.volume &&
      state?.minimumFilling &&
      state?.maximumFilling
    );

  // console.log("STATE", state, state?.unitCost && parseFloat(state?.unitCost));

  const handleDynamics = (val) => {
    if (val === state?.dynamic) return;
    if (val === true)
      setState({ dynamic: true, unitCost: null, price: state?.unitCost });
    if (val === false)
      setState({ dynamic: false, unitCost: state?.price, price: null });
  };

  // handles next button click
  const handleNext = () => {
    // had issues converting string to float and
    // then getting it to show exactly as is in the input fields
    // the temporary solution is to convert the necessary
    // fields in string to float on next button click
    const convertedState = {};
    const fields = [
      "price",
      "unitCost",
      "volume",
      "minimumFilling",
      "maximumFilling",
    ]; //fields to be converted;
    fields.forEach((field) => {
      state[field] &&
        Object.assign(convertedState, {
          [field]: parseFloat(state[field]),
        });
    }); // loop through the field list and check if it has a value in state,
    // convert them and append them to the convertedState object
    setState({
      totalCost: getTotalCost(),
      ...convertedState,
    }); // spread the result to override the original state;
    onNext();
  };

  return (
    <>
      <Box mb={["40px", "40px", "0"]} mx={["24px", 0, 0]}>
        <Box
          as="label"
          fontSize="sm"
          color="var(--color)"
          mb="10px"
          d={["inline-block", "inline-block", "none"]}
        >
          Select Coin
        </Box>
        <RadioGroup
          d={["block", "block", "none"]}
          value={state.token}
          onChange={(value) =>
            setState({
              [listingTypeMap[state.type]]: value,
              token: value,
            })
          }
        >
          <HStack gridGap="14px" flexWrap="wrap">
            {coins.map((coin) => (
              <Radio colorScheme="green" mx="0 !important" value={coin.value}>
                <HStack w="fit-content">
                  <Image
                    boxSize={toLower(coin.label) === "cusd" ? "20px" : "16px"}
                    src={coin.icon}
                  />
                  <Text>{toCoinLocale(coin.value)}</Text>
                </HStack>
              </Radio>
            ))}
          </HStack>
        </RadioGroup>
      </Box>

      <Box
        w="100%"
        bg="white"
        p={["24px", "32px 24px", "56px 40px"]}
        borderRadius={[0, "8px", "16px"]}
      >
        <Stack>
          <Box
            as="label"
            fontSize="sm"
            color="var(--color)"
            mb="10px"
            d={["none", "none", "inline-block"]}
          >
            Select Coin
          </Box>

          <HStack d={["none", "none", "flex"]}>
            {coins.map(({ icon, label, value }) => (
              <CoinButton
                isLoaded={isLoaded}
                disabled={state.token !== value}
                selected={state.token === value}
                onClick={() =>
                  setState({
                    [listingTypeMap[state.type]]: value,
                    token: value,
                  })
                }
                icon={icon}
                label={toCoinLocale(value)}
              />
            ))}
          </HStack>

          <RadioGroup
            value={String(state.dynamic)}
            onChange={(e) => handleDynamics(e === "true" ? true : false)}
            name="ListingType"
            mt="24px !important"
          >
            <HStack>
              <Radio colorScheme="green" value="false" isDisabled>
                Fixed price
              </Radio>
              <Radio colorScheme="green" value="true" isDisabled>
                Dynamics
              </Radio>
            </HStack>
          </RadioGroup>

          <Container m="0 !important" p="0" maxW="2xl">
            <Stack
              mt="40px !important"
              gridGap="20px"
              gridColumnGap={[0, 0, "20px"]}
            >
              <HStack>
                <FormControl flex={[1, 1, ".5"]} isInvalid={isPriceInvalid()}>
                  <FormLabel
                    htmlFor="price"
                    mb="8px"
                    as="label"
                    d="inline-block"
                    fontSize="md"
                    color="#4E4B66"
                    fontWeight="normal"
                  >
                    {!state.dynamic ? "Price" : "Fiat to USD"}
                  </FormLabel>

                  <Skeleton isLoaded={isLoaded}>
                    <NumberInput
                      name="price"
                      min={String(getMarkDown() ?? getRate())}
                      max={String(getMarkUp() ?? getRate())}
                      placeholder={`Enter price ${toCoinLocale(
                        mapSrcUnitField(state.type)
                      )}/${toCoinLocale(
                        !state?.dynamic ? state.token : "usd"
                      )}`}
                      endAdornment={toCoinLocale(mapSrcUnitField(state.type))}
                      value={floatString(
                        state[dynamicsMap[String(state?.dynamic)]]
                      )}
                      onChange={(e) =>
                        setState({
                          [dynamicsMap[String(state?.dynamic)]]: e,
                        })
                      }
                      inputMode="decimal"
                    />
                  </Skeleton>

                  {isCheckingRate && (
                    <CircularProgress
                      isIndeterminate
                      size="12px"
                      color="green"
                    />
                  )}
                  {!isCheckingRate && (
                    <HStack>
                      <Text mt="2px" fontSize="xs">
                        {getCurrentMarketRate()}
                      </Text>

                      {isUpdatingRate && (
                        <CircularProgress
                          isIndeterminate
                          size="12px"
                          color="green"
                        />
                      )}
                    </HStack>
                  )}

                  {isPriceInvalid() && (
                    <FormHelperText
                      fontSize="xs"
                      color="red.500"
                    >{`Price must be between ${Number(
                      getMarkDown()
                    ).toLocaleString()} ${toCoinLocale(
                      mapSrcUnitField(state.type)
                    )} and ${Number(
                      getMarkUp()
                    ).toLocaleString()} ${toCoinLocale(
                      mapSrcUnitField(state.type)
                    )}`}</FormHelperText>
                  )}
                </FormControl>
              </HStack>

              <HStack>
                <FormControl flex={[1, 1, ".5"]}>
                  <Box
                    mb="8px"
                    as="label"
                    d="inline-block"
                    fontSize="md"
                    color="#4E4B66"
                  >
                    Amount of {toCoinLocale(mapDestUnitField(state.type))}
                  </Box>
                  <Skeleton isLoaded={isLoaded}>
                    <NumberInput
                      endAdornment={toCoinLocale(mapDestUnitField(state.type))}
                      placeholder="Enter coin amount"
                      value={floatString(state?.volume)}
                      onChange={(e) => setState({ volume: e })}
                    />
                  </Skeleton>
                </FormControl>
                <Box></Box>
              </HStack>

              {/* {!state.dynamic && ( */}
              <HStack>
                <FormControl flex={[1, 1, ".5"]}>
                  <Box
                    mb="8px"
                    as="label"
                    d="inline-block"
                    fontSize="md"
                    color="#4E4B66"
                  >
                    Total coin value
                  </Box>

                  <Skeleton isLoaded={isLoaded}>
                    <NumberInput
                      disabled
                      endAdornment={toCoinLocale(mapSrcUnitField(state.type))}
                      placeholder="0.00"
                      value={getTotalCost()}
                      onChange={undefined}
                    />
                  </Skeleton>
                </FormControl>
              </HStack>
              {/* )} */}

              <Stack>
                <Box
                  mb="8px"
                  as="label"
                  d="inline-block"
                  fontSize="md"
                  color="#4E4B66"
                >
                  Set limit
                </Box>
                <HStack
                  mt="0 !important"
                  gridGap="20px"
                  gridColumnGap={[0, 0, "20px"]}
                  alignItems="flex-start"
                  flexDir={["column", "column", "row"]}
                >
                  <FormControl flex={[1, 1, ".5"]}>
                    <Skeleton isLoaded={isLoaded}>
                      <NumberInput
                        disabled={!state?.volume}
                        isInvalid={
                          isMinimumInvalid() ||
                          (state.minimumFilling &&
                            state.maximumFilling &&
                            parseFloat(state.minimumFilling) >=
                              parseFloat(state.maximumFilling))
                        }
                        min={0}
                        max={getMaximumFilling()}
                        placeholder={`Enter minimum ${toCoinLocale(
                          mapUnitField(state.type)
                        )} amount`}
                        value={floatString(state?.minimumFilling)}
                        onChange={(e) =>
                          setState({ minimumFilling: setMinimumFilling(e) })
                        }
                        endAdornment="Min"
                      />
                    </Skeleton>

                    {state.minimumFilling &&
                      state.maximumFilling &&
                      parseFloat(state.minimumFilling) >=
                        parseFloat(state.maximumFilling) && (
                        <FormHelperText fontSize="12px" color="red.500">
                          Value must not be greater than or equal to the maximum
                          limit
                        </FormHelperText>
                      )}

                    {isMinimumInvalid() && (
                      <FormHelperText fontSize="12px" color="red.500">
                        Value must be greater than 0 {toCoinLocale(state.token)}{" "}
                        and less than {state.volume} {toCoinLocale(state.token)}
                      </FormHelperText>
                    )}
                  </FormControl>
                  <FormControl
                    ml={["0 !important", "0 !important", "2"]}
                    flex={[1, 1, ".5"]}
                  >
                    <Skeleton isLoaded={isLoaded}>
                      <NumberInput
                        disabled={!state?.volume}
                        isInvalid={isMaximumInvalid()}
                        max={getMaximumFilling()}
                        min={0}
                        placeholder={`Enter maximum ${toCoinLocale(
                          mapUnitField(state.type)
                        )} amount`}
                        value={floatString(state?.maximumFilling)}
                        onChange={(e) =>
                          setState({ maximumFilling: setMaximumFilling(e) })
                        }
                        endAdornment="Max"
                      />
                    </Skeleton>

                    {isMaximumInvalid() && (
                      <FormHelperText fontSize="12px" color="red.500">
                        Value must be greater than 0 {toCoinLocale(state.token)}{" "}
                        and less than or equal to {state.volume}{" "}
                        {toCoinLocale(state.token)}
                      </FormHelperText>
                    )}
                  </FormControl>
                </HStack>
              </Stack>
            </Stack>
          </Container>
        </Stack>
        <HStack
          mt="32px !important"
          w="100%"
          borderTop="1px solid var(--borderColor)"
          pt="40px"
          justifyContent="center"
          gridGap="20px"
        >
          <Button
            disabled={!hasPrevStep()}
            h={["48px", "56px"]}
            minW={["80px", "unset"]}
            w={["160px", "200px"]}
            onClick={onPrev}
            bg="transparent"
            border="2px solid #03A438"
            color="#03A438"
          >
            Previous
          </Button>
          <Button
            disabled={isDisabled()}
            h={["48px", "56px"]}
            minW={["80px", "unset"]}
            w={["160px", "200px"]}
            onClick={handleNext}
          >
            Next
          </Button>
        </HStack>
      </Box>
    </>
  );
};

const Step2 = ({ state, setState }) => {
  const { onNext, onPrev, hasPrevStep } = useSteps();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const paymentMethodsMap = {
    bankTransfer: { name: "Bank Transfer", color: "#F4B740" },
    // changeraId: { name: "Changera", color: "#3B5C9D" },
    bitmamaWallet: { name: "Bitmama Wallet", color: "#04822D" },
  };

  const isDisabled = () => isEmpty(state?.methods);

  const methodsEmpty = () =>
    isEmpty(
      Object.keys(paymentMethodsMap).filter(
        (m) => !state?.methods?.includes(m) && m !== "bitmamaWallet"
      )
    );

  console.log("STATE", state, methodsEmpty());

  const handleRemoveMethod = (method) => {
    const switcher = {
      bankTransfer: () =>
        setState({
          methods: state.methods?.filter((m) => m !== method),
          paymentOption: state?.paymentOption?.filter(
            (v) => v.method !== method
          ),
        }),
      changeraId: () =>
        setState({
          methods: state.methods?.filter((m) => m !== method),
          paymentOption: state?.paymentOption?.filter(
            (v) => v.method !== method
          ),
        }),
      bitmamaWallet: () =>
        setState({
          methods: state.methods?.filter((m) => m !== method),
          useInternalWallet: false,
        }),
    };

    switcher[method]();
  };

  return (
    <Box
      w="100%"
      bg="white"
      p={["24px", "32px 24px", "56px 40px"]}
      borderRadius={[0, "8px", "16px"]}
    >
      <Stack>
        <Box as="label" d="inline-block" fontSize="sm" color="var(--color)">
          Select payment method
        </Box>

        <Text>You can add payment methods for the transactions</Text>

        <Stack gridGap="20px">
          <HStack>
            {state?.methods?.map((method, i) => (
              <Tag
                key={i}
                size="lg"
                borderRadius="10px"
                variant="solid"
                // colorScheme="green"
                bg="#F2F3F4"
                color={paymentMethodsMap[method].color}
                fontWeight="400"
                fontSize="sm"
              >
                <TagLabel>{paymentMethodsMap[method].name}</TagLabel>
                {state?.methods?.length > 1 && (
                  <TagCloseButton
                    onClick={() => handleRemoveMethod(method)}
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    color="#4E4B66"
                  />
                )}
              </Tag>
            ))}

            {!state?.methods.includes("bitmamaWallet") && (
              <Button
                disabled={state?.methods?.length === 2 || methodsEmpty()}
                h="32px"
                minW="91px"
                fontSize="sm"
                bg="transparent"
                border="2px solid #03A438"
                color="#4E4B66"
                onClick={onOpen}
              >
                Add
              </Button>
            )}
          </HStack>

          <FormControl flex="1" maxW="140px">
            <Box
              mb="8px"
              as="label"
              d="inline-block"
              fontSize="md"
              color="#4E4B66"
            >
              Listing time limit
            </Box>
            <Select
              variant="filled"
              h="56px"
              bg="#EFF0F7"
              borderRadius="16px"
              _focus={{
                borderColor: "#06C344",
                boxShadow: "0 0 0 3px #06C3448f",
              }}
              value={state?.timeout ?? ""}
              onChange={(e) => setState({ timeout: Number(e.target.value) })}
              placeholder="Chooose time limit"
            >
              <option value="15">15 min</option>
              <option value="30">30 min</option>
              {/* <option value="bitmamaWallet">Bitmama Wallet</option>
              <option value="bankTransfer">Bank Transfer</option> */}
            </Select>
          </FormControl>
        </Stack>
      </Stack>

      <AddPaymentMethod
        state={state}
        setState={setState}
        isOpen={isOpen}
        onClose={onClose}
      />

      <HStack
        mt="32px !important"
        w="100%"
        borderTop="1px solid var(--borderColor)"
        pt="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          disabled={!hasPrevStep()}
          h="56px"
          w="200px"
          onClick={onPrev}
          bg="transparent"
          border="2px solid #03A438"
          color="#03A438"
        >
          Previous
        </Button>
        <Button
          disabled={isDisabled()}
          h="56px"
          w="200px"
          onClick={() => {
            // console.log("STATE", state);
            onNext();
          }}
        >
          Next
        </Button>
      </HStack>
    </Box>
  );
};

const Step3 = ({ state, setState, userData }) => {
  const toast = useToast();
  const history = useHistory();
  const { onPrev, hasPrevStep, setStep } = useSteps();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: successOpen,
    onOpen: onSuccessOpen,
    onClose: onSuccessClose,
  } = useDisclosure();

  const { id } = useParams();

  // console.log("LISTING ID :: STEP 3", id);

  const [updateListing, { isLoading, data, isSuccess, isError, error }] =
    useUpdateListingMutation();

  const handleConfirm = () => {
    const reqData = { ...state };
    delete reqData?.paymentOption;
    // console.log("UPDATE DATA", reqData);

    updateListing({ ...reqData, id, country: userData?.country });
  };

  const handleSuccessModalClose = () => {
    onSuccessClose();
    history.replace("/dashboard/p2p");
    resetState();
  };

  const countChar = (val, max = 200) => {
    var len = max - val?.length;
    if (len <= 200) {
      return `${len} / ${max}`;
    }
    return `${max} / ${max}`;
  };

  const resetState = useCallback(() => {
    setStep(0); // reset the horizontal stepper;
    setState(iniState); // reset the create listing page state;
    // history.replace("/dashboard/p2pv2/p2p"); // replace current page with the listing page.
  }, [setStep, setState]);

  useEffect(() => {
    if (isSuccess && data) {
      onClose();
      onSuccessOpen();
    }

    if (isError && error)
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: error?.data?.error,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    console.log("ERROR", error);
  }, [
    isSuccess,
    data,
    error,
    isError,
    onClose,
    resetState,
    toast,
    onSuccessOpen,
  ]);

  return (
    <Box
      w="100%"
      bg="white"
      p={["24px", "32px 24px", "56px 40px"]}
      borderRadius={[0, "8px", "16px"]}
    >
      <Stack>
        {/* <Text>You can add upto 3 methods</Text> */}
        <Container
          maxW={["100%", "100%", "xl"]}
          p={["0 !important", "0 !important", "1rem"]}
          m="0 !important"
        >
          <Stack gridGap="20px">
            <FormControl>
              <Box
                as="label"
                d="inline-block"
                fontSize="sm"
                color="var(--color)"
                mb="10px"
              >
                Listing terms
              </Box>

              <Textarea
                maxLength={200}
                pos="relative"
                minH="128px"
                variant="filled"
                bg="#EFF0F7"
                borderRadius="16px"
                _focus={{
                  borderColor: "#06C344",
                  boxShadow: "0 0 0 3px #06C3448f",
                }}
                placeholder="State your terms for this listing"
                value={state.terms ?? ""}
                onChange={(e) => setState({ terms: e.target.value })}
                _before={{
                  content: `"${countChar(state.terms ?? "")}"`,
                  pos: "absolute",
                  bottom: 0,
                  right: 0,
                  w: "200px",
                  h: "100px",
                }}
              ></Textarea>
              <Text mt="10px" fontSize="sm">
                {countChar(state?.terms)}
              </Text>
            </FormControl>
            <FormControl>
              <Box
                as="label"
                d="inline-block"
                fontSize="sm"
                color="var(--color)"
                mb="10px"
              >
                Listing instructions
              </Box>

              <Textarea
                maxLength={200}
                minH="128px"
                variant="filled"
                bg="#EFF0F7"
                borderRadius="16px"
                _focus={{
                  borderColor: "#06C344",
                  boxShadow: "0 0 0 3px #06C3448f",
                }}
                placeholder="List instructions for your listing"
                value={state.instructions ?? ""}
                onChange={(e) => setState({ instructions: e.target.value })}
              />
              <Text mt="10px" fontSize="sm">
                {countChar(state?.instructions)}
              </Text>
            </FormControl>
          </Stack>
        </Container>
      </Stack>

      <ListingPreview
        title="Preview Listing"
        state={state}
        onConfirm={handleConfirm}
        isOpen={isOpen}
        isLoading={isLoading}
        onClose={onClose}
        forUpdate
      />

      <HStack
        mt="32px !important"
        w="100%"
        borderTop="1px solid var(--borderColor)"
        pt="40px"
        justifyContent="center"
        gridGap="20px"
      >
        <Button
          disabled={hasPrevStep()}
          h="56px"
          w="200px"
          onClick={onPrev}
          bg="transparent"
          border="2px solid #03A438"
          color="#03A438"
        >
          Previous
        </Button>
        <Button
          disabled={isLoading}
          isLoading={isLoading}
          h="56px"
          w="200px"
          onClick={onOpen}
        >
          Preview
        </Button>
      </HStack>

      <SuccessModal
        isOpen={successOpen}
        onClose={handleSuccessModalClose}
        title="Ads Updated"
        message={data?.message}
      />
    </Box>
  );
};

const EditListing = (props) => {
  // const {
  //   store: { userData },
  // } = useStore();

  const { id } = useParams();
  // const location = useLocation();

  // const searchParams = new URLSearchParams(location.search);

  // const mapStep = (step) => {
  //   const map = {
  //     pricing: 0,
  //     method: 1,
  //     terms: 2,
  //   };

  //   return map[step];
  // };

  // const currencyMap = {
  //   nigeria: "ngn",
  //   ghana: "ghs",
  // };

  const {
    data: initialState,
    isLoading,
    isSuccess,
  } = useGetListingByIdQuery(id);

  // console.log("INITIAL STATE", initialState, isSuccess);
  console.log("TRANSFORMED STATE", transformListingToState(initialState));

  const [state, setState] = useState(iniState);
  const { onNext, onPrevious, setStep } = useSteps(2);

  const handleState = (data) => {
    setState({ ...state, ...data });
  };

  useEffect(() => {
    // if (searchParams.has("step") && mapStep(searchParams.get("step"))) {
    // setStep(mapStep(searchParams.get("step")));
    setStep(0);
    // }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialState && isSuccess)
      setState(transformListingToState(initialState));
  }, [initialState, isSuccess]);

  const getMaximumFilling = (type) => {
    // if (type === "sell" && state?.volume)
    // return Number(state.volume - deduction(state.volume));
    // if (type === "buy" && state?.volume)
    return Number(state.volume);
  };

  const handleType = (type) => {
    if (state.type === type) return;
    if (state.type !== type)
      handleState({
        type,
        sourceUnit: state.destinationUnit,
        destinationUnit: state.sourceUnit,
        maximumFilling: getMaximumFilling(type),
      });
  };

  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props.logout} />
      <Header />

      <Box className="p2p">
        <Box
          className="p2p-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW={["100%", "container.xl"]} p={["0", "0", "1rem"]}>
            <HStack>
              {isLoading && (
                <CircularProgress isIndeterminate size="22px" color="green" />
              )}

              <Box px={["24px", "0", "0"]}>
                <Heading fontSize="3xl">Update Listing</Heading>

                <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/p2p">P2P</BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink isCurrentPage href="#">
                      Update Listing
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Box>
            </HStack>

            <Steps
              steps={steps}
              mt="40px"
              _btnContainer={{
                mx: ["24px", 0],
                justifyContent: ["center", "center", "flex-start"],
              }}
            >
              <Stack py="40px" gridGap="2px" mx={["24px", 0]}>
                <Text>What would you like to do?</Text>
                <RadioGroup
                  value={state.type}
                  onChange={(e) => handleType(e)}
                  name="ListingType"
                >
                  <HStack>
                    <Radio colorScheme="green" value="buy" isDisabled>
                      I want to buy
                    </Radio>
                    <Radio colorScheme="green" value="sell" isDisabled>
                      I want to sell
                    </Radio>
                  </HStack>
                </RadioGroup>
              </Stack>

              <StepContent>
                <Step1
                  userData={props.userData}
                  isLoaded={!isLoading}
                  state={state}
                  setState={handleState}
                  onNext={onNext}
                  onPrevious={onPrevious}
                />
                <Step2
                  userData={props.userData}
                  isLoaded={!isLoading}
                  state={state}
                  setState={handleState}
                />
                <Step3
                  userData={props.userData}
                  isLoaded={!isLoading}
                  state={state}
                  setState={handleState}
                />
              </StepContent>
            </Steps>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default EditListing;
